// project import
import AuthWrapper from 'sections/auth/AuthWrapper';
import AuthLogin from 'sections/auth/auth-forms/AuthLogin';

// ================================|| LOGIN ||================================ //

const Login = () => {
    return (
        <AuthWrapper withLogo>
            <h1 className="sr-only">Login</h1>
            <AuthLogin />
        </AuthWrapper>
    );
};

export default Login;
